module.exports = __webpack_public_path__ + "static/img/10.c42b43f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/10.png
// module id = ho/g
// module chunks = 0